// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container-logo[data-v-72dc3f54] {\r\n  flex-direction: column;\n}\n.size_icon[data-v-72dc3f54] {\r\n  width: 100px;\r\n  height: 100px;\r\n  -o-object-fit: cover;\r\n     object-fit: cover;\r\n  text-align: center;\r\n  border-radius: 50%;\r\n  margin: 20px 0;\n}\r\n", ""]);
// Exports
module.exports = exports;
